import {Pipe, PipeTransform} from '@angular/core';
import {GlobalNotification} from '../../../@backend/modules/@users/models/global-notification.model';

@Pipe({
  name: 'notificationColor'
})
export class NotificationColorPipe implements PipeTransform {

  transform(value: GlobalNotification): string {
    if (value.notificationType === 'INFO') {
      return '#29b6f6';
    } else if (value.notificationType === 'WARNING') {
      return '#ff9800';
    } else if (value.notificationType === 'ERROR') {
      return '#ff5252';
    } else if (value.notificationType === 'SUCCESS') {
      return '#00c853';
    }
  }

}
